import * as Lucide from "lucide-react";

export const siteConfig = {
  contactMethods: [
    {
      icon: Lucide.Phone,
      title: "Call Us",
      description: "Speak directly with our team",
      contact: "+975-17112040 / 77353525",
    },
    {
      icon: Lucide.Mail,
      title: "Email Us",
      description: "Send us your detailed inquiry",
      contact: "tradingvisiontech@gmail.com",
    },
    {
      icon: Lucide.MessageCircle,
      title: "Visit Our Office",
      description: "Meet us in person",
      contact: "Motithang, Thimphu 11001",
    },
  ],
  faqCategories: [
    {
      id: "services",
      title: "Services & Products",
      icon: Lucide.Settings,
      questions: [
        {
          question: "What industries do you serve?",
          answer:
            "We serve seven key sectors: Energy, Medical, Telecommunication, Construction, Agriculture, Education, and Recreational & General Supplies. Our diverse portfolio ensures we can meet the technology needs across Bhutan's entire economy.",
        },
        {
          question:
            "Do you provide custom solutions for specific requirements?",
          answer:
            "Yes, we work closely with our clients to understand their unique needs and can source or customize solutions accordingly. Our global network allows us to find specialized products that meet specific technical requirements.",
        },
        {
          question: "What types of energy solutions do you offer?",
          answer:
            "Our energy sector solutions include renewable energy technologies, power generation equipment, energy storage systems, smart grid technologies, and sustainable infrastructure solutions from leading global manufacturers.",
        },
        {
          question: "Do you supply medical equipment and pharmaceuticals?",
          answer:
            "Yes, we provide high-quality medical equipment, diagnostic tools, laboratory instruments, and pharmaceutical products that meet international standards and regulatory requirements for the healthcare sector in Bhutan.",
        },
      ],
    },
    {
      id: "partnerships",
      title: "Partnerships & Quality",
      icon: Lucide.Shield,
      color: "from-blue-500 to-cyan-600",
      questions: [
        {
          question: "How do you ensure product quality?",
          answer:
            "We only partner with trusted global brands and manufacturers who meet international quality standards. All our products undergo rigorous quality checks and come with proper certifications and warranties.",
        },
        {
          question: "Who are your international partners?",
          answer:
            "We maintain strategic partnerships with leading manufacturers and suppliers across Asia, Europe, and North America. Our international offices in Kolkata, Bangkok, and Singapore help us maintain these relationships and ensure quality sourcing.",
        },
        {
          question: "Do you provide warranties and after-sales support?",
          answer:
            "Yes, all our products come with manufacturer warranties and we provide comprehensive after-sales support including installation guidance, maintenance services, and technical support through our local and international network.",
        },
        {
          question: "How do you verify the authenticity of products?",
          answer:
            "We work directly with authorized distributors and manufacturers, maintain proper documentation and certificates of authenticity, and have established verification processes to ensure all products are genuine and meet specified standards.",
        },
      ],
    },
    {
      id: "operations",
      title: "Operations & Delivery",
      icon: Lucide.Truck,
      color: "from-purple-500 to-violet-600",
      questions: [
        {
          question: "What are your delivery timeframes?",
          answer:
            "Delivery times vary depending on product availability and location. Standard items typically take 2-4 weeks, while specialized equipment may take 6-12 weeks. We provide detailed timelines for each order and keep clients updated throughout the process.",
        },
        {
          question: "Do you deliver to all locations in Bhutan?",
          answer:
            "Yes, we deliver throughout Bhutan from our offices in Thimphu, Phuntsholing, and Gelephu. Our distribution network ensures we can reach even remote locations efficiently and safely.",
        },
        {
          question: "How do you handle customs and import procedures?",
          answer:
            "We handle all customs clearance, import documentation, and regulatory compliance requirements. Our experienced team manages the entire import process to ensure smooth and legal entry of all products into Bhutan.",
        },
        {
          question: "What are your payment terms and methods?",
          answer:
            "We offer flexible payment terms including advance payments, letters of credit, and installment options for large orders. We accept bank transfers, checks, and other standard business payment methods.",
        },
      ],
    },
    {
      id: "support",
      title: "Support & Contact",
      icon: Lucide.Users,
      color: "from-orange-500 to-red-600",
      questions: [
        {
          question: "How can I get a quote for products or services?",
          answer:
            "You can contact us via phone (+975-17112040 / 77353525), email (tradingvisiontech@gmail.com), or visit our offices. Provide us with your requirements and we'll prepare a detailed quote with pricing and delivery information.",
        },
        {
          question: "Do you provide technical training and support?",
          answer:
            "Yes, we offer technical training for complex equipment and systems. Our team can provide on-site training, user manuals, and ongoing technical support to ensure optimal use of the products we supply.",
        },
        {
          question: "What languages do you provide support in?",
          answer:
            "We provide support in English and Dzongkha to ensure clear communication with all our clients. Our" +
            " multilingual team can assist with technical documentation and support in these languages.",
        },
        {
          question: "How do I track my order status?",
          answer:
            "Once you place an order, we provide regular updates via phone and email. You can also contact our customer service team anytime for real-time status updates on your order and delivery schedule.",
        },
      ],
    },
  ],
  process: [
    {
      step: "01",
      title: "Consultation",
      description:
        "Understanding your specific requirements and technical needs",
      icon: Lucide.Users,
    },
    {
      step: "02",
      title: "Solution Design",
      description: "Crafting customized solutions using our global network",
      icon: Lucide.Lightbulb,
    },
    {
      step: "03",
      title: "Procurement",
      description: "Sourcing from verified suppliers with quality assurance",
      icon: Lucide.Database,
    },
    {
      step: "04",
      title: "Delivery & Support",
      description: "Efficient delivery with ongoing technical support",
      icon: Lucide.Truck,
    },
  ],
  capabilities: [
    {
      icon: Lucide.Globe,
      title: "Global Sourcing Network",
      description:
        "Access to international suppliers and manufacturers across multiple continents",
      features: [
        "Strategic partnerships worldwide",
        "Quality supplier verification",
        "Competitive pricing",
      ],
    },
    {
      icon: Lucide.Shield,
      title: "Quality Assurance",
      description:
        "Rigorous quality control processes ensuring international standards compliance",
      features: [
        "ISO certified suppliers",
        "Product testing and verification",
        "Warranty and support",
      ],
    },
    {
      icon: Lucide.Truck,
      title: "Efficient Logistics",
      description:
        "Streamlined supply chain management from source to destination",
      features: [
        "Customs clearance expertise",
        "Nationwide delivery network",
        "Real-time tracking",
      ],
    },
    {
      icon: Lucide.Users,
      title: "Expert Consultation",
      description:
        "Technical expertise and consultation services for optimal solution selection",
      features: [
        "Industry specialists",
        "Custom solution design",
        "Technical training",
      ],
    },
  ],

  sectors: [
    {
      icon: Lucide.Zap,
      title: "Energy Sector",
      description:
        "Advanced energy solutions for sustainable power generation and distribution",
      features: [
        "Renewable energy systems (Solar, Wind, Hydro)",
        "Smart grid technologies and automation",
        "Energy storage and battery solutions",
        "Power generation equipment",
        "Energy efficiency monitoring systems",
        "Sustainable infrastructure development",
      ],
      benefits: [
        "Reduced carbon footprint",
        "Lower operational costs",
        "Reliable power supply",
        "Future-ready infrastructure",
      ],
    },
    {
      icon: Lucide.Stethoscope,
      title: "Medical Sector",
      description:
        "High-quality medical equipment and pharmaceutical products for healthcare excellence",

      features: [
        "Advanced diagnostic equipment",
        "Surgical instruments and tools",
        "Laboratory testing systems",
        "Medical imaging technology",
        "Patient monitoring devices",
        "Pharmaceutical products and supplies",
      ],
      benefits: [
        "Improved patient outcomes",
        "Enhanced diagnostic accuracy",
        "Streamlined healthcare delivery",
        "International quality standards",
      ],
    },
    {
      icon: Lucide.Radio,
      title: "Telecommunication",
      description:
        "State-of-the-art communication systems and networking infrastructure",

      features: [
        "5G and wireless communication systems",
        "Network infrastructure equipment",
        "Satellite communication solutions",
        "Fiber optic technologies",
        "Cybersecurity and network protection",
        "IoT and smart connectivity solutions",
      ],
      benefits: [
        "Enhanced connectivity",
        "Faster data transmission",
        "Improved network security",
        "Scalable infrastructure",
      ],
    },
    {
      icon: Lucide.Hammer,
      title: "Construction",
      description:
        "Superior building materials and modern construction technologies",

      features: [
        "Heavy machinery and equipment",
        "Advanced building materials",
        "Construction automation tools",
        "Safety equipment and systems",
        "Project management software",
        "Sustainable construction solutions",
      ],
      benefits: [
        "Faster project completion",
        "Enhanced safety standards",
        "Durable construction quality",
        "Cost-effective solutions",
      ],
    },
    {
      icon: Lucide.Wheat,
      title: "Agriculture",
      description:
        "Advanced farming tools and sustainable agricultural solutions",

      features: [
        "Precision farming equipment",
        "Irrigation and water management systems",
        "Agricultural drones and sensors",
        "Crop monitoring technologies",
        "Sustainable fertilizers and pesticides",
        "Post-harvest processing equipment",
      ],
      benefits: [
        "Increased crop yields",
        "Reduced resource waste",
        "Sustainable farming practices",
        "Data-driven agriculture",
      ],
    },
    {
      icon: Lucide.GraduationCap,
      title: "Education",
      description: "Innovative learning tools and digital education platforms",

      features: [
        "Interactive learning technologies",
        "Digital classroom solutions",
        "Educational software and platforms",
        "Laboratory equipment for schools",
        "Distance learning infrastructure",
        "Student management systems",
      ],
      benefits: [
        "Enhanced learning experiences",
        "Improved educational outcomes",
        "Digital literacy development",
        "Accessible education delivery",
      ],
    },
    {
      icon: Lucide.Gamepad2,
      title: "Recreational & General",
      description:
        "Sports equipment, entertainment technology, and consumer goods",
      features: [
        "Sports and fitness equipment",
        "Entertainment and gaming systems",
        "Consumer electronics",
        "Recreational facility equipment",
        "Event management technologies",
        "Lifestyle and wellness products",
      ],
      benefits: [
        "Enhanced quality of life",
        "Community engagement",
        "Health and wellness promotion",
        "Entertainment value",
      ],
    },
  ],

  featureStats: [
    { number: "500+", label: "Products Available", icon: Lucide.Layers },
    { number: "50+", label: "Global Partners", icon: Lucide.Handshake },
    { number: "99%", label: "Client Satisfaction", icon: Lucide.Star },
    { number: "24/7", label: "Support Available", icon: Lucide.Clock },
  ],
  locations: [
    {
      type: "Head Office",
      city: "Thimphu",
      country: "Bhutan",
      address: "PO Box 501, Motithang, Thimphu 11001",
      icon: Lucide.Building2,
    },
    {
      type: "Branch Office",
      city: "Phuntsholing",
      country: "Bhutan",
      address: "Border town operations center",
      icon: Lucide.MapPin,
    },
    {
      type: "Branch Office",
      city: "Gelephu",
      country: "Bhutan",
      address: "Southern region operations",
      icon: Lucide.MapPin,
    },
    {
      type: "International Office",
      city: "Kolkata",
      country: "India",
      address: "Regional hub for South Asia",
      icon: Lucide.Globe,
    },
    {
      type: "International Office",
      city: "Bangkok",
      country: "Thailand",
      address: "Southeast Asia operations",
      icon: Lucide.Globe,
    },
    {
      type: "International Office",
      city: "Singapore",
      country: "Singapore",
      address: "Asia-Pacific headquarters",
      icon: Lucide.Globe,
    },
  ],
  values: [
    {
      icon: Lucide.Award,
      title: "Excellence",
      description:
        "We maintain the highest standards in everything we do, ensuring quality and reliability in all our products and services.",
    },
    {
      icon: Lucide.Handshake,
      title: "Trust",
      description:
        "Building lasting relationships through transparency, integrity, and consistent delivery on our promises.",
    },
    {
      icon: Lucide.Target,
      title: "Innovation",
      description:
        "Continuously seeking new technologies and solutions to drive progress and create value for our clients.",
    },
    {
      icon: Lucide.Users,
      title: "Partnership",
      description:
        "Collaborating closely with clients and suppliers to achieve mutual success and sustainable growth.",
    },
  ],
  getMileStones: [
    {
      year: "2008",
      title: "Company Founded",
      description:
        "Established VisionTech Trading with a vision to revolutionize Bhutan's technology landscape.",
      icon: Lucide.Building2,
    },
    {
      year: "2012",
      title: "International Expansion",
      description:
        "Extended operations to Kolkata, Bangkok, and Singapore, building global partnerships.",
      icon: Lucide.Globe,
    },
    {
      year: "2016",
      title: "Multi-Sector Growth",
      description:
        "Expanded into 7 key sectors including energy, medical, and telecommunications.",
      icon: Lucide.TrendingUp,
    },
    {
      year: "2020",
      title: "Digital Transformation",
      description:
        "Led Bhutan's digital transformation with cutting-edge technology solutions.",
      icon: Lucide.Target,
    },
  ],
  clients: [
    {
      title: "Ministry of Energy and Natural Resources",
      logo: "/ministry_resource_logo.png",
    },
    { title: "Bhutan National Bank", logo: "/bnb_logo.svg" },
    { title: "UNICEF", logo: "/UNICEF_logo.jpg" },
    {
      title: "Asian Development Bank",
      logo: "/asian_development_bank_logo.png",
    },
    { title: "WWF", logo: "/wwf_logo.png" },
    {
      title: "Druk Green Power Corporation",
      logo: "/druk_green_power_logo.jpg",
    },
    { title: "Bhutan Broadcasting Service", logo: "/bbs_logo.jpg" },
    { title: "Royal University of Bhutan", logo: "/rub_logo.png" },
  ],
  whyUsPoints: [
    {
      icon: Lucide.Globe,
      title: "Global Reach, Local Expertise",
      description:
        "Presence in Bhutan and internationally, bringing the best global products tailored to the Bhutanese market.",
    },
    {
      icon: Lucide.Shield,
      title: "Quality Assurance",
      description:
        "We only partner with trusted global brands to ensure high-quality standards.",
    },
    {
      icon: Lucide.Truck,
      title: "Reliable Supply Chain",
      description:
        "Seamless distribution network ensures timely and efficient delivery.",
    },
    {
      icon: Lucide.Users,
      title: "Diverse Industry Expertise",
      description:
        "Extensive product portfolio spans multiple industries, ensuring comprehensive solutions.",
    },
  ],

  services: [
    {
      icon: Lucide.Zap,
      title: "Energy Sector",
      description:
        "Advanced energy solutions, sustainable power technologies, and innovative infrastructure.",
    },
    {
      icon: Lucide.Stethoscope,
      title: "Medical Sector",
      description:
        "High-quality medical equipment, diagnostic tools, and pharmaceutical products.",
    },
    {
      icon: Lucide.Radio,
      title: "Telecommunication",
      description:
        "State-of-the-art communication systems and networking solutions.",
    },
    {
      icon: Lucide.Hammer,
      title: "Construction",
      description:
        "Superior building materials, heavy machinery, and modern construction technologies.",
    },
    {
      icon: Lucide.Wheat,
      title: "Agriculture",
      description:
        "Advanced farming tools, fertilizers, and sustainable agricultural solutions.",
    },
    {
      icon: Lucide.GraduationCap,
      title: "Education",
      description:
        "Innovative learning tools, smart classrooms, and digital education platforms.",
    },
    {
      icon: Lucide.Gamepad2,
      title: "Recreational & General",
      description:
        "Sports equipment, entertainment technology, and consumer goods.",
    },
  ],
  getStats: [
    { number: 15, label: "Years Experience", Icon: Lucide.Building2 },
    { number: 7, label: "Industry Sectors", Icon: Lucide.Target },
    { number: 50, label: "Trusted Clients", Icon: Lucide.Users },
    { number: 6, label: "Global Locations", Icon: Lucide.Globe },
  ],
  getNavHeaders: () => {
    const list = [
      {
        label: "Home",
        href: "/",
      },
      {
        label: "About Us",
        href: "/about",
      },
      {
        label: "Features",
        href: "/features",
      },
      {
        label: "FAQ",
        href: "/faq",
      },
    ];

    return list;
  },
};
